import styled from "styled-components";

interface IButtonNotification {
  isLoading?: any;
}
export const ButtonNotification = styled.button<IButtonNotification>`
  ${(props) => `
  background-color: ${"#F2F3F8"};
  color: ${"#002E6C"};
  cursor: ${props.isLoading ? "default" : "pointer"};
  font-family: ${props.theme.fontFamilies.primaryFont};
`}
  align-items: center;
  border-radius: 0.8rem;
  border: 1px solid #002e6c;
  display: flex;
  font-size: 1.4rem;
  font-weight: 700;
  height: 5rem;
  justify-content: center;
  margin-left: 0.5rem;
  width: 20rem;

  img {
    height: 3rem;
    width: 3rem;
  }
  .img-notification {
    height: 2.4rem;
    width: 2rem;
  }
`;

interface IContainerCommon {
  width?: string;
}
export const ContainerCommon = styled.div<IContainerCommon>`
  ${(props) => `
    background-color: ${props.theme.colors.white};
    width:${props.width ? props.width : "49.5rem"};
  `}
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  padding: 4rem 2rem;
  
  .scroll {
    height: auto;
    overflow: auto;
    width: auto;
  }
  .scroll::-webkit-scrollbar {
    width: 3px;
  }
  
  .scroll::-webkit-scrollbar-thumb {
    border-radius: 10px;
    box-shadow: inset 0 0 6px #76BC21;
  }
  .card-style{
    background: #FFFFFF;
    box-shadow: 0px 2px 15px rgba(167, 167, 167, 0.3);
    margin-top: 2rem;
    max-height: 26vh;
    overflow-y: scroll:
  }
  .max-height-padding{
    overflow-y: scroll;
    max-height: 90vh;
    padding: 1rem;
  }
  
`;
